import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue";
import _imports_0 from '@/assets/EnableWhatapp.png';
import _imports_1 from '@/assets/reminders.png';
import _imports_2 from '@/assets/policies.png';
import _imports_3 from '@/assets/AI-Chat-24px.svg';
const _hoisted_1 = { class: "whatsapp-enable-content" };
const _hoisted_2 = {
    key: 0,
    class: "whatsapp-initial-state"
};
const _hoisted_3 = {
    key: 1,
    class: "whatsapp-sent-state"
};
const _hoisted_4 = { class: "whatsapp-enable-heading" };
const _hoisted_5 = { class: "whatsapp-buttons" };
import { ref, watch } from 'vue';
import { whatsAppNumber } from '@/config';
import SimpleDrawerPanel from './SimpleDrawerPanel.vue';
import MGButton from './MGButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'WhatsAppEnableDrawer',
    props: {
        phoneNumber: {}
    },
    emits: ["done", "closed", "enable"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const currentState = ref('initial');
        const isOpen = ref(false);
        function openDrawer() {
            currentState.value = 'initial';
            isOpen.value = true;
        }
        function closeDrawer() {
            isOpen.value = false;
        }
        function handleEnable() {
            emit('enable');
            currentState.value = 'sent';
        }
        function handleDone() {
            closeDrawer();
            emit('done');
            window.location.href = `https://wa.me/${whatsAppNumber}`;
        }
        function handleResend() {
            emit('enable');
        }
        watch(isOpen, (open) => {
            if (!open) {
                currentState.value = 'initial';
                emit('closed');
            }
        });
        __expose({
            openDrawer,
            closeDrawer,
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(SimpleDrawerPanel, {
                modelValue: isOpen.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((isOpen).value = $event)),
                title: "WhatsApp AI Assistant"
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        (currentState.value === 'initial')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _cache[1] || (_cache[1] = _createElementVNode("img", {
                                    src: _imports_0,
                                    alt: "WhatsApp",
                                    class: "whatsapp-enable-image"
                                }, null, -1)),
                                _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "whatsapp-enable-heading" }, "Your personal financial assistant", -1)),
                                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "whatsapp-features" }, [
                                    _createElementVNode("div", { class: "whatsapp-feature-item" }, [
                                        _createElementVNode("img", {
                                            src: _imports_1,
                                            alt: "",
                                            class: "feature-icon"
                                        }),
                                        _createElementVNode("span", { class: "feature-text" }, "Get reminders before your policies expire")
                                    ]),
                                    _createElementVNode("div", { class: "whatsapp-feature-item" }, [
                                        _createElementVNode("img", {
                                            src: _imports_2,
                                            alt: "",
                                            class: "feature-icon"
                                        }),
                                        _createElementVNode("span", { class: "feature-text" }, "Add policies with ease by sharing documents")
                                    ]),
                                    _createElementVNode("div", { class: "whatsapp-feature-item" }, [
                                        _createElementVNode("img", {
                                            src: _imports_3,
                                            alt: "",
                                            class: "feature-icon feature-icon-circle"
                                        }),
                                        _createElementVNode("span", { class: "feature-text" }, "Your queries answered in minutes")
                                    ])
                                ], -1)),
                                _createVNode(MGButton, {
                                    text: "Enable WhatsApp",
                                    fullWidth: true,
                                    onClick: handleEnable
                                })
                            ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                _cache[4] || (_cache[4] = _createElementVNode("img", {
                                    src: _imports_0,
                                    alt: "WhatsApp",
                                    class: "whatsapp-enable-image-small"
                                }, null, -1)),
                                _createElementVNode("h2", _hoisted_4, "We have sent a WhatsApp message to " + _toDisplayString(_ctx.phoneNumber), 1),
                                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "whatsapp-instructions" }, [
                                    _createElementVNode("p", { class: "instruction-text" }, "Once received, open the message and tap \"I'm in\"."),
                                    _createElementVNode("p", { class: "instruction-text" }, "Your AI assistant is available 24/7 for all your personal finance queries."),
                                    _createElementVNode("p", { class: "instruction-text" }, "Tap resend below if your message doesn't arrive within a few minutes.")
                                ], -1)),
                                _createElementVNode("div", _hoisted_5, [
                                    _createVNode(MGButton, {
                                        text: "Done",
                                        fullWidth: true,
                                        onClick: handleDone
                                    }),
                                    _createVNode(MGButton, {
                                        text: "Resend message",
                                        fullWidth: true,
                                        textOnly: true,
                                        onClick: handleResend
                                    })
                                ])
                            ]))
                    ])
                ]),
                _: 1
            }, 8, ["modelValue"]));
        };
    }
});
